// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/bg-home.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/bg-home-mobile.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  background-color: rgba(var(--white));
}
.home-page__header {
  padding: 1.5rem 2.5rem;
}
@media (max-width: 768px) {
  .home-page__header {
    padding: 1.5rem 1rem;
  }
}
.home-page__tagline {
  font-family: var(--merriweather);
  color: rgba(var(--white));
  font-size: 3.5rem;
  font-weight: 400;
  line-height: 1;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  white-space: pre;
  margin-bottom: 21vw;
}
@media (max-width: 768px) {
  .home-page__tagline {
    font-size: 1.5rem;
    margin-bottom: 48vw;
    line-height: 1.33;
  }
}
.home-page__business-inf {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 4.5rem auto 5.375rem;
}
@media (max-width: 1300px) {
  .home-page__business-inf {
    width: auto;
    margin: 4.5rem 1rem 5.375rem;
  }
}
@media (max-width: 768px) {
  .home-page__business-inf {
    margin: 2.5rem 1rem 3.5rem;
  }
}
.home-page .bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  position: relative;
  background-size: contain;
  height: calc(50vw - 1.5rem);
  margin: 1.5rem;
  border-radius: 1rem;
}
@media (max-width: 768px) {
  .home-page .bg {
    margin: 1rem;
    height: 108vw;
    background-position: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
}
.home-page .test {
  margin-top: 100px;
}

.business-inf {
  width: 76.25rem;
  background-color: rgba(var(--grey-100));
  border-radius: 12px;
  padding: 1.5rem;
  box-sizing: border-box;
}
.business-inf__content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 1.5rem 0;
}
.business-inf__content-text {
  font-family: var(--merriweather);
  color: rgba(var(--grey-600));
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.625;
  text-align: center;
  white-space: pre-line;
}
@media (max-width: 1300px) {
  .business-inf__content-text {
    white-space: normal;
  }
}
@media (max-width: 768px) {
  .business-inf__content-text {
    line-height: 1.57;
    font-size: 0.875rem;
  }
}
@media (max-width: 768px) {
  .business-inf__logo {
    height: 2.09125rem;
  }
}
@media (max-width: 1300px) {
  .business-inf {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;AACE;EACE,sBAAA;AACJ;AACI;EAHF;IAII,oBAAA;EAEJ;AACF;AACE;EACE,gCAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AACI;EAdF;IAeI,iBAAA;IACA,mBAAA;IACA,iBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;AACJ;AACI;EAPF;IAQI,WAAA;IACA,4BAAA;EAEJ;AACF;AAAI;EAZF;IAaI,0BAAA;EAGJ;AACF;AAAE;EACE,yDAAA;EACA,4BAAA;EACA,kBAAA;EACA,wBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AAEJ;AAAI;EATF;IAUI,YAAA;IACA,aAAA;IACA,2BAAA;IACA,yDAAA;EAGJ;AACF;AAAE;EACE,iBAAA;AAEJ;;AAEA;EACE,eAAA;EACA,uCAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AACJ;AACI;EACE,gCAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AACN;AACM;EATF;IAUI,mBAAA;EAEN;AACF;AAAM;EAbF;IAcI,iBAAA;IACA,mBAAA;EAGN;AACF;AAEI;EADF;IAEI,kBAAA;EACJ;AACF;AAEE;EAvCF;IAwCI,WAAA;EACF;AACF","sourcesContent":[".home-page {\n  background-color: rgba(var(--white));\n\n  &__header {\n    padding: 1.5rem 2.5rem;\n\n    @media (max-width: 768px) {\n      padding: 1.5rem 1rem;\n    }\n  }\n\n  &__tagline {\n    font-family: var(--merriweather);\n    color: rgba(var(--white));\n    font-size: 3.5rem;\n    font-weight: 400;\n    line-height: 1;\n    text-align: center;\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translate(-50%, 0);\n    white-space: pre;\n    margin-bottom: 21vw;\n\n    @media (max-width: 768px) {\n      font-size: 1.5rem;\n      margin-bottom: 48vw;\n      line-height: 1.33;\n    }\n  }\n\n  &__business-inf {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 4.5rem auto 5.375rem;\n\n    @media (max-width: 1300px) {\n      width: auto;\n      margin: 4.5rem 1rem 5.375rem;\n    }\n\n    @media (max-width: 768px) {\n      margin: 2.5rem 1rem 3.5rem;\n    }\n  }\n\n  .bg {\n    background-image: url('../../../public/bg-home.jpg');\n    background-repeat: no-repeat;\n    position: relative;\n    background-size: contain;\n    height: calc(50vw - 1.5rem);\n    margin: 1.5rem;\n    border-radius: 1rem;\n\n    @media (max-width: 768px) {\n      margin: 1rem;\n      height: 108vw;\n      background-position: center;\n      background-image: url('../../../public/bg-home-mobile.jpg');\n    }\n  }\n\n  .test {\n    margin-top: 100px;\n  }\n}\n\n.business-inf {\n  width: 76.25rem;\n  background-color: rgba(var(--grey-100));\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-sizing: border-box;\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    margin: 1.5rem 0;\n\n    &-text {\n      font-family: var(--merriweather);\n      color: rgba(var(--grey-600));\n      font-weight: 300;\n      font-size: 1rem;\n      line-height: 1.625;\n      text-align: center;\n      white-space: pre-line;\n\n      @media (max-width: 1300px) {\n        white-space: normal;\n      }\n\n      @media (max-width: 768px) {\n        line-height: 1.57;\n        font-size: 0.875rem;\n      }\n    }\n  }\n\n  &__logo {\n    @media (max-width: 768px) {\n      height: 2.09125rem;\n    }\n  }\n\n  @media (max-width: 1300px) {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
